import { ReactNode } from "react";

interface Props {
  title?: string;
  icon?: string;
  children?: ReactNode;
  leftTitle?: string;
  titleClass?: string;
  containerClass?: string;
  className?: string;
}

const ModalTemplate: React.FC<Props> = (props) => {
  const { children, title, icon, leftTitle, titleClass = "", containerClass = "", className } = props;

  return (
    <div>
      <div className="flex flex-row justify-between p-1 font-bold">
        <div className={`flex items-center text-lg ${containerClass}`}>
          <i className={`${icon} text-pkc-primary ${className && className}`} />
          <div className={` mr-2 font-medium ${titleClass}`}>{title}</div>
        </div>
        {leftTitle && <div>{leftTitle}</div>}
      </div>
      {children}
    </div>
  );
};

export default ModalTemplate;
